import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { ThemeProvider } from '@mui/material';
import { theme } from '@myme/utils';
import '@myme/utils/src/i18n/config';
import { AuthProvider } from 'src/contexts/AuthContext';
import { handleError } from 'src/utils';
import { GlobalStyles } from './GlobalStyles';
import { PageInitializer } from './components/layout/page/PageInitializer';
import { ScrollReset } from './components/layout/ScrollReset';
import { PromptProvider } from './contexts/PromptContext';
import { createTheme } from './themes/muiTheme';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      onError: error => {
        handleError(error, { navigateToErrorPage: true });
      }
    },
    mutations: {
      onError: error => {
        handleError(error);
      }
    }
  }
});

const toastContainerProps: ToastContainerProps = {
  position: 'bottom-left',
  theme: 'dark',
  autoClose: 4000,
  hideProgressBar: true,
  limit: 3,
  closeOnClick: true,
  rtl: false,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  draggable: true,
  toastStyle: { backgroundColor: theme.colors.backgroundSecondary }
};

export const App = () => {
  const muiTheme = createTheme('default');

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider theme={muiTheme}>
          <PromptProvider>
            <ScrollReset />
            <GlobalStyles />
            <PageInitializer />
            <ToastContainer {...toastContainerProps} />
          </PromptProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
